import React,{ useLayoutEffect,useContext,useState, useEffect } from 'react';
import { DataContext } from 'contexts/DataContext';
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import * as am5radar from "@amcharts/amcharts5/radar";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import am5themes_Dark from "@amcharts/amcharts5/themes/Dark";

import { getStatus } from 'pages/Assessment/api';

const StatusChart = () => {
    const dataContext = useContext(DataContext);
    const [status, setStatus] = useState(false as any);
    const [total, setTotal] = useState(false as any);

    useEffect(() => {
        dataContext.changeShowLoader(true);
        if(dataContext.loading) return;
        if(!dataContext.currentAssessment) return;

        getStatus(dataContext.currentOrganization, dataContext.currentAssessment).then((response) => {
            setStatus(response.status);
            setTotal(response.total);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataContext.loading, dataContext.currentAssessment]);

    useLayoutEffect(() => {
        if(!status) return;
        let root = am5.Root.new("StatusChartDiv");
        root._licenseApplied();

        root.setThemes([
            am5themes_Animated.new(root),
            am5themes_Dark.new(root)
        ]);
        
        var data = status;
        
        //Functions colors
        var scoreColors : am5.Color[] = [
            am5.color("#CCCC43"),
            am5.color("#6E6E6E"),
            am5.color("#3F5A98"),
            am5.color("#532A7B"),
            am5.color("#3F8A49"),
            am5.color("#BB291C"),
        ];

        var maturityColors : am5.Color[] = [
            am5.color("#f4f450"),
            am5.color("#8f8f8f"),
            am5.color("#5479c9"),
            am5.color("#7c42b7"),
            am5.color("#53b560"),
            am5.color("#e52f22"),
        ];
        
        // Create chart
        var chart = root.container.children.push(
            am5radar.RadarChart.new(root, {
                panX: false,
                panY: false,
                wheelX: "none",
                wheelY: "none",
                startAngle: -84,
                endAngle: 264,
                innerRadius: am5.percent(40)
            })
        );
        
        // Add cursor
        var cursor = chart.set("cursor", am5radar.RadarCursor.new(root, {
            behavior: "zoomX"
        }));
        cursor.lineY.set("visible", false);
        
        // Create axes and their renderers
        var xRenderer = am5radar.AxisRendererCircular.new(root, {
            cellStartLocation: 0.2,
            cellEndLocation: 0.8
        });
        
        xRenderer.labels.template.setAll({
            radius: 10
        });
        
        var xAxis = chart.xAxes.push(
            am5xy.CategoryAxis.new(root, {
                maxDeviation: 0,
                categoryField: "category",
                renderer: xRenderer,
                //tooltip: am5.Tooltip.new(root, {})
            })
        );
        
        xAxis.data.setAll(data);
        
        var yAxis = chart.yAxes.push(
            am5xy.ValueAxis.new(root, {
                renderer: am5radar.AxisRendererRadial.new(root, {}),
                min:0,
                max:100
            })
        );
        
        // Create series
        // Score
        var series1 = chart.series.push(
            am5radar.RadarColumnSeries.new(root, {
                name: "Score",
                xAxis: xAxis,
                yAxis: yAxis,
                valueYField: "value1",
                categoryXField: "category",
            })
        );
        
        series1.columns.template.setAll({
            tooltipText: "[fontSize: 12px]Copertura: {valueY}%[/]",
            width: am5.percent(100),
            cornerRadius: 0,
        });
        
        series1.data.setAll(data);
        series1.appear(1000);
        
        //Maturity
        var series2 = chart.series.push(
            am5radar.RadarColumnSeries.new(root, {
                name: "Maturity",
                xAxis: xAxis,
                yAxis: yAxis,
                valueYField: "value2",
                categoryXField: "category"
            })
        );
        
        series2.columns.template.setAll({
            tooltipText: "[fontSize: 12px]Maturità: {valueY}%[/]",
            width: am5.percent(100),
            cornerRadius: 0,
        });
        
        series2.data.setAll(data);
        series2.appear(1000);
        
        // Set colors for function columns
        series1.columns.template.adapters.add("fill", function (fill, target) {
            return scoreColors[series1.columns.indexOf(target)];
        });
        series1.columns.template.adapters.add("stroke", function (stroke, target) {
            return scoreColors[series1.columns.indexOf(target)];
        });
        
        series2.columns.template.adapters.add("fill", function (fill, target) {
            return maturityColors[series2.columns.indexOf(target)];
        });
        series2.columns.template.adapters.add("stroke", function (stroke, target) {
            return maturityColors[series2.columns.indexOf(target)];
        });
        
        
        xAxis.get("renderer").labels.template.setAll({
            fontSize: 12,
        });
        
        
        chart.children.unshift(am5.Label.new(root, {
            text: `${total.score}[#FFF fontSize: 10px]%\n[/][#FFF fontSize: 10px]COPERTURA[/]\n${total.maturity}[#FFF fontSize: 10px]%\n[/][#FFF fontSize: 10px]MATURITA'[/]`,
            fontSize: 30,
            fontWeight: "500",
            textAlign: "center",
            fontFamily: "Saira Semi Condensed",
            lineHeight: 1.1,
            fill: am5.color("#df8f39"),
            x: am5.percent(50),
            centerX: am5.percent(50),
            y: am5.percent(50),
            centerY: am5.percent(50),
            paddingTop: 0,
            paddingBottom: 0
        }));
        
        // Animate chart
        chart.appear(1000, 100);

        
        chart.children.unshift(am5.Label.new(root, {
            text: "Maturità e Copertura per funzione",
            fontSize: 14,
            fontWeight: "500",
            textAlign: "center",
            fontFamily: "Saira Semi Condensed",
            x: am5.percent(50),
            y: am5.percent(100),
            centerX: am5.percent(50),
            centerY: am5.percent(100),
            paddingTop: 0,
            paddingBottom: -5
        }));

        dataContext.changeShowLoader(false);

        return () => {
          root.dispose();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [status]);
    
      return (
        <div id="StatusChartDiv" style={{ width: "100%", height: "450px",marginTop:'-70px' }}></div>
      );
}

export default StatusChart;